import getProviderReducer from './providerReducer';

export * from './providerActions';
export default getProviderReducer;